import React from 'react';
import { useUser } from 'components/hooks';


const withPermission = (Component, viewPermission) => (props) => {
  const { roleSelected, user } = useUser();

  function validPermission(projectId, permissionAction) {
    if (user.admin) return true;
    if (!projectId) return false;
    if (roleSelected &&  !roleSelected.permission) roleSelected.permission = [];
    if (!roleSelected || !roleSelected.permission.hasOwnProperty(projectId)) return false;

    const authPermission = roleSelected.permission[`${projectId}`][viewPermission];

    if (authPermission && authPermission.hasOwnProperty(permissionAction)) {
      return authPermission[permissionAction];
    }

    return false;
  }

  return (
    <>
      <Component
        {...props}
        permission={roleSelected.permission}
        validPermission={validPermission}
      />
    </>
  );
}

export default withPermission;
